module.exports = __webpack_public_path__ + "res/img/my_on.40721307.gif";